module.exports = __webpack_public_path__ + "static/media/globalSearch.d97e0974.png";